import React from 'react'
import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import bannerLupa from '../assets/banner-lupa.jpg'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    height: '100vh',
    width: '100%',
  },

  bannerFilter: {
    position: 'absolute',
    height: '100vh',
    width: '100%',
    background: '#1b6494',
    zIndex: 2,
    opacity: 0.8,
  },

  banner: {
    height: '100vh',
    width: '100%',
    zIndex: 1,
    objectFit: 'cover',
  },
}))

const BannerCampanha = ({ pageProps }) => {
  const classes = useStyles()

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} className={classes.bannerFilter}></Grid>
      <Grid item xs={12}>
        <img src={bannerLupa} className={classes.banner} />
      </Grid>
    </Grid>
  )
}

export default BannerCampanha
